function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.89029 7.00726L6.67546 12.7923C6.80926 12.9262 6.98788 13 7.17833 13C7.36878 13 7.5474 12.9262 7.6812 12.7923L8.10724 12.3664C8.38447 12.0888 8.38447 11.6378 8.10724 11.3606L3.2493 6.5027L8.11263 1.63936C8.24644 1.50545 8.32031 1.32694 8.32031 1.13659C8.32031 0.946033 8.24644 0.767523 8.11263 0.633508L7.68659 0.207682C7.55268 0.0737724 7.37417 9.236e-07 7.18372 9.17546e-07C6.99327 9.11492e-07 6.81465 0.0737724 6.68085 0.207682L0.89029 5.99802C0.75617 6.13236 0.682504 6.31171 0.682926 6.50238C0.682504 6.69378 0.75617 6.87303 0.89029 7.00726Z",
  fill: "black"
});

var SvgBackButton = function SvgBackButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-button.a32c0b22.svg";
export { ForwardRef as ReactComponent };